import React, { FC, useMemo } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { biEvents } from 'api/bi-events';
import { BI_BUTTON_NAME, BI_STEP_NAME } from 'config/bi';
import { StepId } from 'config/steps';
import { RelatedAppsSmall, EditSmall, MobileSmall } from '@wix/wix-ui-icons-common';
import { redirects } from 'api/redirects';
import { useIsMobile } from 'hooks/useIsMobile';
import { ActionsGrid } from 'components/ActionsGrid/ActionsGrid';

export const StoreReadyStepActions: FC = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const handleDesignSite = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.StoreReady],
      button_name: BI_BUTTON_NAME.DESIGN_SITE,
    });
    redirects.redirectToDesignSite();
  };

  const handleManageProducts = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.StoreReady],
      button_name: BI_BUTTON_NAME.MANAGE_PRODUCTS,
    });
    redirects.redirectToManageProducts();
  };

  const handleOpenMobileApp = () => {
    biEvents.actionClicked({
      screenName: BI_STEP_NAME[StepId.StoreReady],
      button_name: BI_BUTTON_NAME.OPEN_MOBILE_APP,
    });
    redirects.redirectToMobileApp();
  };

  const items = useMemo(() => {
    if (isMobile) {
      return [
        {
          title: t('store-ready-step.content.actions.item.mobile-app.title'),
          description: t('store-ready-step.content.actions.item.mobile-app.description'),
          buttonText: t('store-ready-step.content.actions.item.mobile-app.button-text'),
          buttonIcon: <MobileSmall />,
          onClick: handleOpenMobileApp,
        },
      ];
    }

    return [
      {
        title: t('store-ready-step.content.actions.item.design-site.title'),
        description: t('store-ready-step.content.actions.item.design-site.description'),
        buttonText: t('store-ready-step.content.actions.item.design-site.button-text'),
        buttonIcon: <EditSmall />,
        onClick: handleDesignSite,
      },
      {
        title: t('store-ready-step.content.actions.item.manage-products.title'),
        description: t('store-ready-step.content.actions.item.manage-products.description'),
        buttonText: t('store-ready-step.content.actions.item.manage-products.button-text'),
        buttonIcon: <RelatedAppsSmall />,
        onClick: handleManageProducts,
      },
    ];
  }, [t, isMobile]);

  return <ActionsGrid items={items} />;
};
